import React from 'react';
import { Section } from './ui/Section';
export function Testimonials({
  limit = 3,
  className = ''
}: {
  limit?: number;
  className?: string;
}) {
  const testimonials = [{
    initials: 'MG',
    quote: 'En la primera semana dejé de llevarme el trabajo a la cama. El protocolo de cierre diario cambió todo.',
    author: 'Miguel G., Madrid'
  }, {
    initials: 'LP',
    quote: 'Por fin tengo un sistema para cuando mi cabeza colapsa. El Protocolo SOS me salvó en plena reunión.',
    author: 'Laura P., Barcelona · Freelance Digital'
  }, {
    initials: 'RM',
    quote: 'Dejé de procrastinar decisiones porque ya no tengo ese ruido de fondo constante. Vale cada euro.',
    author: 'Roberto M., Valencia'
  }, {
    initials: 'CR',
    quote: 'El Tomo 2 transformó mis noches. Mis hijos notan que llego diferente a casa desde la segunda semana.',
    author: 'Cristina R. · Madrid | Kit + Acelerador'
  }, {
    initials: 'SC',
    quote: 'El Checklist de Cierre Diario es lo que más agradezco. Por fin duermo sin repasar mentalmente el día entero.',
    author: 'Sofía C. · Barcelona | Freelance'
  }, {
    initials: 'PA',
    quote: 'El Acelerador 10X me permitió implementar todo en un fin de semana. Sin él hubiera tardado meses en arrancar.',
    author: 'Pablo A. · Bilbao | Directivo'
  }, {
    initials: 'VL',
    quote: 'El Mapa de Nodos Mentales™ me llegó justo cuando más lo necesitaba. Vaciaba la cabeza en 10 minutos y rendía el doble.',
    author: 'Valentina L. · Sevilla | Profesora'
  }, {
    initials: 'DM',
    quote: 'Llevaba 3 años con ese ruido de fondo constante. En 2 semanas con el Kit era otra persona. Sin exagerar.',
    author: 'Diego M. · Málaga | Desarrollador'
  }];
  const displayTestimonials = limit ? testimonials.slice(0, limit) : testimonials;
  return <Section className={className} data-id="element-195">
      <div className={`grid gap-6 ${limit === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-id="element-196">
        {displayTestimonials.map((t, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-2xl p-6 flex flex-col hover:border-neutral-700 transition-colors" data-id="element-197">
            <div className="flex items-center gap-3 mb-4" data-id="element-198">
              <div className="w-10 h-10 rounded-full bg-neutral-800 flex items-center justify-center font-bold text-neutral-300" data-id="element-199">
                {t.initials}
              </div>
              <div className="flex text-brand-accent text-sm" data-id="element-200">⭐⭐⭐⭐⭐</div>
            </div>
            <p className="text-neutral-300 italic mb-6 flex-grow" data-id="element-201">
              "{t.quote}"
            </p>
            <p className="text-sm text-neutral-500 font-medium" data-id="element-202">— {t.author}</p>
          </div>)}
      </div>
    </Section>;
}